"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SAFERENT_REQUEST_TYPES = exports.VALIDITY_INTERVAL_IN_DAYS = exports.SAFERENT_BEDROOM_CODES = exports.SAFERENT_PACKAGE_NAMES = exports.SAFERENT_ERROR_CODES = exports.SAFERENT_REQUEST_STATUSES = void 0;
exports.SAFERENT_REQUEST_STATUSES = {
    INTERNAL_ERROR: 'internal_error',
    SAFERENT_ERROR: 'saferent_error',
    SENDING: 'sending',
    ARGYLE: 'argyle',
    READY: 'READY',
    RESUBMIT: 'RESUBMIT',
    PARTIAL: 'PARTIAL',
    PENDING: 'PENDING'
};
exports.SAFERENT_ERROR_CODES = {
    '-1': 'Internal Error',
    '0': 'No error',
    '2': 'Failed to send the report ',
    '100': 'Invalid XML',
    '1000': 'Authorization validation',
    '3000': 'Invalid vendor code',
    '4000': 'Terms and conditions need to be accepted',
    '5000': 'Request data validation issue'
};
exports.SAFERENT_PACKAGE_NAMES = {
    ALL_PACKAGES: 'Default',
    ID_INCOME_CREDIT: 'CRD',
    CRIMINAL: 'CRM',
    INCOME: 'VOI'
};
exports.SAFERENT_BEDROOM_CODES = {
    0: '06', // studio
    1: '01',
    2: '02',
    3: '03',
    4: '04'
};
exports.VALIDITY_INTERVAL_IN_DAYS = 30;
exports.SAFERENT_REQUEST_TYPES = { INITIAL: 'initial', FINAL: 'final' };
